export enum BurglarAlarmLabel {
  Local = "Local",
  Monitored = "Central/Monitored",
  No = "No",
}
